import { ComponentTypes } from "../../Components/ComponentFactory/types";
import SpliceSvgIcon from "../../Components/Icons/SpliceIcon";
import { commonFieldFormatter } from "../../formatters";

import { MdArrowForward, MdCable, MdOutlineElderly, MdOutlineFilterAlt, MdOutlinePercent, MdStraighten } from "react-icons/md";
import { PiEquals } from "react-icons/pi";

const coreSettings = [
    {
        type: ComponentTypes.STAT,
        id: "transceiver_res",
        formatter: commonFieldFormatter,
        measure: "dBm"
    },
    {
        type: ComponentTypes.STAT,
        id: "splitter_res",
        formatter: commonFieldFormatter,
        measure: "dB"
    },
    {
        type: ComponentTypes.STAT,
        id: "splice_qty_res",
        formatter: commonFieldFormatter,
        measure: "dB"
    },
    {
        type: ComponentTypes.STAT,
        id: "aging_margin_res",
        formatter: commonFieldFormatter,
        measure: "dB"
    },
    {
        type: ComponentTypes.STAT,
        id: "connectors_res",
        formatter: commonFieldFormatter,
        measure: "dB"
    },
    {
        type: ComponentTypes.STAT,
        id: "measurement_error_res",
        formatter: commonFieldFormatter,
        measure: "dB"
    },
    {
        type: ComponentTypes.STAT,
        id: "total_distance_res",
        formatter: commonFieldFormatter,
        measure: "dBm"
    }
]

const images = [
    {
        type: ComponentTypes.ICON,
        dummy: true,
        empty: true
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [MdArrowForward],
        name: "Transceiver",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        style: {transform: 'rotate(90deg)'},
        icons: [MdOutlineFilterAlt],
        name: "Splitter",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [SpliceSvgIcon],
        name: "SpliceQTY",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [MdOutlineElderly],
        name: "Aging",
        id: "aging_img",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [MdCable],
        name: "Connectors",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [MdOutlinePercent],
        name: "Measure",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [MdStraighten],
        name: "Distance",
        width: 50
    },
    {
        type: ComponentTypes.ICON,
        dummy: true,
        icons: [PiEquals],
        name: "Result",
        width: 50
    }
]

export const BudgetSettings: any = {
    downlink: {
        images,
        xgspon: [
            {
                type: ComponentTypes.STAT,
                defVal: 'XGS-PON',
                id: "name",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true,
            }, 
            ...coreSettings,
            {
                type: ComponentTypes.STAT,
                id: "budget_result_xgspon",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            },
        ],
        gpon: [
            {
                type: ComponentTypes.STAT,
                defVal: 'GPON',
                id: "name",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            }, ...coreSettings,
            {
                type: ComponentTypes.STAT,
                id: "budget_result_gpon",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            },
        ],
    },
    uplink: {
        images,
        xgspon: [
            {
                type: ComponentTypes.STAT,
                defVal: 'XGS-PON',
                id: "name",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            }, 
            ...coreSettings,
            {
                type: ComponentTypes.STAT,
                id: "budget_result_xgspon",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            },
        ],
        gpon: [
            {
                type: ComponentTypes.STAT,
                defVal: 'GPON',
                id: "name",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            }, 
            ...coreSettings,
            {
                type: ComponentTypes.STAT,
                id: "budget_result_gpon",
                formatter: commonFieldFormatter,
                measure: "dBm",
                bold: true
            },
        ],
    }
}



